import { useEffect, useMemo, useRef } from "react";

function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
  let timeout: ReturnType<typeof setTimeout>;
  return function (...args: Parameters<T>) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

export const useScrollWrapper = ({
  trigger,
  paddingRight = "8px",
}: {
  trigger: any;
  paddingRight?: string;
}) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const setPadding = () => {
      requestAnimationFrame(() => {
        if (el.scrollHeight > el.clientHeight) {
          el.style.paddingRight = paddingRight;
        } else {
          el.style.paddingRight = "0";
        }
      });
    };

    const debouncedSetPadding = debounce(setPadding, 100);

    debouncedSetPadding();

    const resizeObserver = new ResizeObserver(debouncedSetPadding);
    resizeObserver.observe(el);

    return () => {
      resizeObserver.disconnect();
    };
  }, [trigger, paddingRight]);

  return useMemo(() => ({ scrollRef }), [trigger]);
};
